import { AppRoutes, PaneemType } from "../../constants";
import { useAppDispatch } from "../../redux";
import { setIsPaneemTypeSelected } from "../../AppSlice";
import { overrideAttempts } from "../ImageCapture/ImageCaptureSlice";
import { useNavigate, useParams } from "react-router-dom";

export default function Override() {
  const dispatch = useAppDispatch();
  const { number } = useParams();

  const navigate = useNavigate();

  if (number && !isNaN(Number(number))) dispatch(overrideAttempts(Number(number) >= 0 ? Number(number) : 0));
  else dispatch(overrideAttempts(2));

  if (number && !isNaN(Number(number)) && Number(number) >= 0) dispatch(setIsPaneemTypeSelected(PaneemType.paneem));
  else dispatch(setIsPaneemTypeSelected(PaneemType.statusCheck));

  navigate(AppRoutes.home);

  return null;
}
